/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import React from 'react';

import { Liste } from '@mairistem/liste';

import { URL_TYPES_RECONNAISSANCE } from '@/constants';
import { FiltresListeActes } from '@/components/Common';

import ActeReconnaissanceListeTable from './ActeReconnaissanceListeTable';

interface ActeReconnaissanceListeProps {
  actes?: Array<any>;
  count?: number;
  perPage?: number;
  loading?: boolean;
  onLoad?: any;
  onSort?: any;
  /** Réduit la liste à la seule colonne du nom, pour la sidebar de la fiche. */
  sidebar?: boolean;
}

const ActeReconnaissanceListe = (props: ActeReconnaissanceListeProps) => {
  const {
    actes,
    count,
    perPage,
    loading,
    onLoad,
    onSort,
    sidebar,
    ...handlers
  } = props;

  const tableau = (
    <ActeReconnaissanceListeTable
      items={actes}
      loading={loading}
      count={count}
      perPage={perPage}
      onLoad={onLoad}
      onSort={onSort}
      sidebar={sidebar}
    />
  );

  return (
    <Liste
      title="Liste des actes de reconnaissance"
      searchable
      search={{
        clearable: true,
        placeholder:
          "Rechercher par n° d'acte, nom ou prénoms de l'enfant ou de ses parents...",
      }}
      {...handlers}
    >
      <Liste.Content>
        {sidebar ? (
          tableau
        ) : (
          <FiltresListeActes
            urlSousTypes={URL_TYPES_RECONNAISSANCE}
            cleCode="codeEtatCivil"
          >
            {tableau}
          </FiltresListeActes>
        )}
      </Liste.Content>
    </Liste>
  );
};

export default ActeReconnaissanceListe;
